import classNames from 'classnames'
import { useCallback, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { AccountsList } from '../../components'
import { ContextualPage } from '../../components/contextual-page'
import { TransactionList } from '../../components/transcation-list'
import { Paths } from '../../config/routes'
import { useExportTransactions } from '../../hooks/export-transactions'
import { MasaAccount } from '../../models'

export interface AccountsProps {
    asset?: string | null
    account?: string | null
}

export function Accounts({ asset, account }: AccountsProps) {
    const [downloadedFile, setDownloadedFile] = useState(false)
    const [open, setOpen] = useState(false)
    const history = useHistory()

    const handleOnClick = useCallback(
        (account: MasaAccount) => {
            if (!account) {
                return history.push(`${Paths.ACCOUNTS}?asset=${asset}`)
            }
            const accountId =
                account.type === 'CRYPTO' ? account.accountId : account.id

            history.push(
                `${Paths.ACCOUNTS}?asset=${asset}&account=${accountId}`,
            )
        },
        [asset, history],
    )

    const hanldeSelectCurrency = useCallback(
        (currency: string) => {
            history.push(`${Paths.ACCOUNTS}?asset=${currency}`)
        },
        [history],
    )

    const [filter, providers] = useMemo(() => {
        const filterList = [] as string[]
        let provider: string | undefined = undefined

        if (asset && account) {
            filterList.push(account as string)
        }
        if (asset) {
            provider = asset
        }
        return [filterList, provider]
    }, [asset, account])

    const updateCurrency = (currency: string | undefined) => {
        if (!currency) {
            history.push(`${Paths.ACCOUNTS}`)
        } else {
            history.push(`${Paths.ACCOUNTS}?asset=${currency}`)
        }
    }

    const { call, fileLocation } = useExportTransactions({
        type: asset && asset === 'USD' ? 'bank' : 'crypto',
        filter: account ? account : undefined,
        providers: asset ? asset : undefined,
    })
    // Trigger file download
    if (!downloadedFile && fileLocation) {
        const link = document.createElement('a')
        link.href = fileLocation
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setDownloadedFile(true)
    }

    const handleExportTransactions = useCallback(() => {
        call()
        setDownloadedFile(false)
    }, [call])

    const transactionsStyles = classNames(
        'col-span-5 lg:col-span-3 3xl:col-span-4 hidden sm:block',
    )

    const accountsStyles = classNames('col-span-5 lg:col-span-2 3xl:col-span-1')
    return (
        <div className='grid h-full grid-flow-col grid-cols-5 gap-4 py-4 grid-rows-accounts-2 lg:grid-rows-accounts-1'>
            <div className={accountsStyles}>
                <AccountsList
                    full
                    onClick={asset ? handleOnClick : hanldeSelectCurrency}
                    groupBy={['amount', 'currency']}
                    group={!asset}
                    currency={asset}
                    selectedAccount={account}
                    updateCurrency={updateCurrency}
                />
            </div>
            <div className={transactionsStyles}>
                <TransactionList
                    type={asset && asset === 'USD' ? 'bank' : ('crypto' as any)}
                    filter={filter}
                    providers={providers}
                    showPlaceholder={!asset && !account}
                    fillVertical
                    exportTransactions={handleExportTransactions}
                />
            </div>

            <div className='sm:hidden'>
                <ContextualPage
                    show={true}
                    height={open ? '5/6' : '2/6'}
                    onClose={() => setOpen(false)}
                    onOpen={() => setOpen(true)}
                    className='pt-8'
                    open={open}>
                    <TransactionList
                        type={
                            asset && asset === 'USD'
                                ? 'bank'
                                : ('crypto' as any)
                        }
                        filter={filter}
                        providers={providers}
                        showPlaceholder={!asset && !account}
                        fillVertical
                        exportTransactions={handleExportTransactions}
                        mobile
                    />
                </ContextualPage>
            </div>
        </div>
    )
}
